import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "loader is-size-2 mx-auto" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "notification is-danger"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Failed to load worker run ")
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Worker run ID: ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "subtitle has-text-weight-bold" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Worker ")
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Name: ", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Revision: ", -1)
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Version: ", -1)
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Worker version ID: ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, "Worker version creation date: ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "Worker ID: ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle has-text-weight-bold" }, "Model", -1)
const _hoisted_27 = { class: "mt-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", null, "Name: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "State: ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("strong", null, "Size: ", -1)
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "Model version ID: ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("strong", null, "Model version tag:", -1)
const _hoisted_34 = { class: "tag mx-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", null, "Model ID: ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("summary", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Configuration")
], -1)
const _hoisted_37 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-info is-light" }, " No model. ", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_41 = {
  key: 2,
  class: "mb-5"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle has-text-weight-bold" }, "Configuration", -1)
const _hoisted_43 = { class: "mt-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("strong", null, "Name: ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("summary", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Configuration")
], -1)
const _hoisted_46 = { class: "mt-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("strong", null, "Configuration ID: ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("strong", null, "Archived: ", -1)
const _hoisted_49 = {
  key: 3,
  class: "mb-5"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-info is-light" }, " No configuration. ", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_53 = { key: 4 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle has-text-weight-bold" }, "Process", -1)
const _hoisted_55 = { class: "mt-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", null, "Name: ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("strong", null, "State: ", -1)
const _hoisted_58 = { class: "mt-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("strong", null, "Process ID: ", -1)
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "field is-grouped" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" View model version ")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" View worker version ")
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" View process ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemId = _resolveComponent("ItemId")!
  const _component_ProcessStateTag = _resolveComponent("ProcessStateTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.modalState,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalState) = $event))
  }, {
    footer: _withCtx(({ close }) => [
      _createElementVNode("span", {
        class: "button",
        onClick: close
      }, "Close", 8, _hoisted_60),
      _createElementVNode("div", _hoisted_61, [
        (_ctx.workerRun?.model_version?.id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "button",
              to: { name: 'model-version', params: { versionId: _ctx.workerRun?.model_version.id } }
            }, {
              default: _withCtx(() => [
                _hoisted_62
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.workerRun?.worker_version.id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "button",
              to: { name: 'worker-version', params: { versionId: _ctx.workerRun?.worker_version.id } }
            }, {
              default: _withCtx(() => [
                _hoisted_63
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.workerRun?.process.id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              class: "button is-success",
              to: { name: 'process-details', params: { id: _ctx.workerRun.process.id } }
            }, {
              default: _withCtx(() => [
                _hoisted_64
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_ItemId, { "item-id": _ctx.workerRunId }, null, 8, ["item-id"]),
              _createTextVNode(": " + _toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.workerRun)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_ItemId, { "item-id": _ctx.workerRunId }, null, 8, ["item-id"])
                ]),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", {
                      class: _normalizeClass(["tag is-uppercase is-light mx-1", _ctx.workerClass(_ctx.workerRun.worker_version.worker.type)])
                    }, _toDisplayString(_ctx.workerType?.display_name ?? _ctx.workerRun.worker_version.worker.type), 3)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_ctx.workerRun.worker_version.worker.name || '—'), 1)
                    ]),
                    (_ctx.workerRun.worker_version.revision_url)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("a", {
                            href: _ctx.workerRun.worker_version.revision_url,
                            target: "_blank"
                          }, _toDisplayString(_ctx.truncateLong(_ctx.workerRun.worker_version.revision_url)), 9, _hoisted_17)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(_ctx.workerRun.worker_version.version), 1)
                        ])),
                    _createElementVNode("p", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_ItemId, {
                        "item-id": _ctx.workerRun.worker_version.id
                      }, null, 8, ["item-id"])
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_22,
                      _createTextVNode(" " + _toDisplayString(_ctx.versionCreatedDate), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_23,
                      _createVNode(_component_ItemId, {
                        "item-id": _ctx.workerRun.worker_version.worker.id
                      }, null, 8, ["item-id"])
                    ])
                  ])
                ]),
                _hoisted_24,
                (!_ctx.loading && _ctx.workerRun?.model_version?.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("p", null, [
                          _hoisted_28,
                          _createTextVNode(" " + _toDisplayString(_ctx.workerRun.model_version.model.name || '—'), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_29,
                          _createElementVNode("span", {
                            class: _normalizeClass(["tag is-light mx-1", _ctx.modelVersionStateClass(_ctx.workerRun.model_version.state)])
                          }, _toDisplayString(_ctx.workerRun.model_version.state), 3)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_30,
                          _createTextVNode(" " + _toDisplayString(_ctx.workerRun.model_version.size), 1)
                        ]),
                        _createElementVNode("p", _hoisted_31, [
                          _hoisted_32,
                          _createVNode(_component_ItemId, {
                            "item-id": _ctx.workerRun.model_version.id
                          }, null, 8, ["item-id"])
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_33,
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.workerRun.model_version.tag || '—'), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_35,
                          _createVNode(_component_ItemId, {
                            "item-id": _ctx.workerRun.model_version.model.id
                          }, null, 8, ["item-id"])
                        ]),
                        _createElementVNode("details", null, [
                          _hoisted_36,
                          _createElementVNode("pre", null, _toDisplayString(_ctx.workerRun.model_version.configuration), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39)),
                _hoisted_40,
                (!_ctx.loading && _ctx.workerRun?.configuration?.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("p", null, [
                          _hoisted_44,
                          _createTextVNode(" " + _toDisplayString(_ctx.workerRun.configuration.name || '—'), 1)
                        ]),
                        _createElementVNode("details", null, [
                          _hoisted_45,
                          _createElementVNode("pre", null, _toDisplayString(_ctx.workerRun.configuration.configuration), 1)
                        ]),
                        _createElementVNode("p", _hoisted_46, [
                          _hoisted_47,
                          _createVNode(_component_ItemId, {
                            "item-id": _ctx.workerRun.configuration.id
                          }, null, 8, ["item-id"])
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_48,
                          _createTextVNode(" " + _toDisplayString(_ctx.humanBoolean(_ctx.workerRun.configuration.archived)), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51)),
                _hoisted_52,
                (!_ctx.loading && _ctx.workerRun?.process?.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("p", null, [
                          _hoisted_56,
                          _createTextVNode(" " + _toDisplayString(_ctx.workerRun.process.name || '—'), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _hoisted_57,
                          _createVNode(_component_ProcessStateTag, {
                            class: "mx-1",
                            state: _ctx.workerRun.process.state
                          }, null, 8, ["state"])
                        ]),
                        _createElementVNode("p", _hoisted_58, [
                          _hoisted_59,
                          _createVNode(_component_ItemId, {
                            "item-id": _ctx.workerRun.process.id
                          }, null, 8, ["item-id"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}